import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ProjectPaymentStoreActions,
  ProjectPaymentStoreSelectors,
  ProjectPaymentStoreReducer,
} from './index';
import { ProjectPaymentDto } from '@cradua/data';

@Injectable()
export class ProjectPaymentFacade {
  constructor(
    private store: Store<ProjectPaymentStoreReducer.ProjectPaymentPartialState>
  ) {}

  projectManagementRecord$ = this.store.select(
    ProjectPaymentStoreSelectors.getSelected
  );
  searchedStudentRecord$ = this.store.select(
    ProjectPaymentStoreSelectors.getSearchStudentRecord
  );

  projectManagementRecordError$ = this.store.select(
    ProjectPaymentStoreSelectors.getProjectPaymentError
  );

  getselected() {
    return this.store.select(ProjectPaymentStoreSelectors.getSelected);
  }

  get isLoadingProjectPayment() {
    this.store.dispatch(ProjectPaymentStoreActions.loadProjectPayment());
    return this.store.select(
      ProjectPaymentStoreSelectors.loadingProjectPayment
    );
  }

  get loadProjectPayment() {
    this.store.dispatch(ProjectPaymentStoreActions.loadProjectPayment());
    return this.store.select(ProjectPaymentStoreSelectors.getAllProjectPayment);
  }

  searchProjectPaymentRecord(query) {
    this.store.dispatch(
      ProjectPaymentStoreActions.searchProjectPaymentRecord({ query })
    );
  }

  addProjectPayment(newProjectPayment: ProjectPaymentDto[]) {
    this.store.dispatch(
      ProjectPaymentStoreActions.addProjectPayment({
        newProjectPayment,
      })
    );
  }

  updateProjectPayment(updateProjectPayment: ProjectPaymentDto[]) {
    this.store.dispatch(
      ProjectPaymentStoreActions.updateProjectPayment({
        updateProjectPayment,
      })
    );
  }

  removeProjectPayment(ids: string[]) {
    this.store.dispatch(
      ProjectPaymentStoreActions.removeProjectPayment({ ids })
    );
  }
}
